import { useContext, useState } from 'react';
import Spinner from '../../../components/spinner/spinner';
import { ClassNameSpinner } from '../../../components/spinner/types/spinnerProps';
import Chip from '../../../components/shared/chip/chip';
import { ObjectType, PatternType } from '../../../contexts/types/card';
import ElaboratorsAndInstitutions from '../shared/ElaboratorsAndInstitutions/elaboratorsAndInstitutions';
import KrFormContext, { endangeredAreaAttributes, KrEndangeredAreaFormTypes } from '../../../contexts/krFormContext';
import { CollectiveFormContextProps } from '../krFormView/components/shared/types/formContextProps';
import Location from '../krFormView/components/location';
import MainCriterionForArea from '../krFormView/components/mainCriterionForArea';
import ObservationInstructions from '../krFormView/components/observationInstructions';
import './collectiveEditionView.scss';

const CollectiveEndangeredAreaForm = (props: CollectiveFormContextProps) => {
    const { krForm, setkrForm } = useContext(KrFormContext);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [loading, setLoading] = useState<boolean>(false);

    const deleteKr = (attributes: endangeredAreaAttributes) => {
        if (attributes?.numeR_IDENTYFIKACYJNY !== undefined) {
            props.onDelete([attributes?.numeR_IDENTYFIKACYJNY]);
        }
    }

    const elaboratorsSectionTitle = (
        <>
            <h2>5. Wypełniający kartę</h2>
            <h2>6. Kategoria i numer kwalifikacji geologicznych</h2>
            <h2>7. Instytucja</h2>
        </>
    );

    return (
        <div>
            {loading && <Spinner spinnerClass={ClassNameSpinner.Big} isMist={true} />}
            <div className='collectiveIds'>
                <h3>wybrane karty</h3>
                {props.forms.map((form: KrEndangeredAreaFormTypes) => {
                    return <Chip key={form.endangeredAreaAttributes?.id}
                        title={form.endangeredAreaAttributes?.numeR_IDENTYFIKACYJNY}
                        onlySingleTag={true}
                        mainClass={true}
                        onClose={deleteKr}
                        data={form.endangeredAreaAttributes} />
                })}
            </div>
            <div className='collective-fields'>
                <Location objectType={ObjectType.KRTZ} version={PatternType.P2020} collectiveEdition={true} editMode={true}
                    forms={props.forms} actions={props.actions} setActions={props.setActions} onDelete={props.onDelete} />
                <MainCriterionForArea objectType={ObjectType.KRTZ} version={PatternType.P2020} collectiveEdition={true} editMode={true}
                    forms={props.forms} actions={props.actions} setActions={props.setActions} onDelete={props.onDelete} />
                <ObservationInstructions objectType={ObjectType.KRTZ} version={PatternType.P2020} collectiveEdition={true} editMode={true}
                    forms={props.forms} actions={props.actions} setActions={props.setActions} onDelete={props.onDelete} />
                <ElaboratorsAndInstitutions sectionTitle={elaboratorsSectionTitle} context={krForm} setContext={setkrForm} isKR={true} collectiveEdition={true} editMode={true}
                    forms={props.forms} actions={props.actions} setActions={props.setActions} onDelete={props.onDelete} />
            </div>
        </div>
    )
}

export default CollectiveEndangeredAreaForm;
